export const ProgressBar = ({ progress, noColors=false, hideNumber = false, className }: { progress: number, noColors?:boolean, hideNumber?:boolean, className?: string}) => {
  return (
    <div className={`flex items-center`}>
        {!hideNumber && <span className={`font-medium mr-2 ${progress >= 80 && !noColors ? 'text-green-600' : progress >= 70 && !noColors ? 'text-amber-600' : `${ !noColors ? 'text-red-600' : 'text-blue-600'}`}`}>
            {progress}%
        </span>}
        <div className={`h-2 bg-slate-200 rounded-full overflow-hidden ${className}`}>
            <div 
            className={`h-full rounded-full ${progress >= 80 && !noColors ? 'bg-green-600' : progress >= 70 && !noColors ? 'bg-amber-600' : `${ !noColors ? 'bg-red-600' : 'bg-blue-600'}`}`} 
            style={{ width: `${progress}%` }}
            ></div>
        </div>
    </div>
  )}